import { apiSlice } from './apiSlice'

import type { PnLRow } from '../../pages/dashboard/pnl/PnLTable'

/**
 * Commercial Position (PnL) dashboard data — `GET /api/v1/dashboard/pnl`.
 *
 * Mirrors FastAPI `PnLDashboardResponse` (camelCase aliases). BE returns DATA
 * ROWS only; column/format config lives in `pages/dashboard/pnl/pnlColumns.ts`.
 * Source: Report DB (`DATABASE_URL_REPORT`). Spec: plan/PBI_Dashboard.md.
 */
export interface PnLDashboardResponse {
  purchases: PnLRow[]
  sales: PnLRow[]
  futures: PnLRow[]
  inventory: PnLRow[]
  supplierM2M: PnLRow[]
  longShort: PnLRow[]
  m2mPnl: PnLRow[]
  /** Latest two `capture_pnl_daily` snapshot dates → dynamic M2M column labels. */
  m2mTodayDate?: string | null
  m2mPrevDate?: string | null
  physicalPrice: PnLRow[]
  exchangeRate: PnLRow[]
  marketPrice: PnLRow[]
}

export interface PnLDashboardQuery {
  /** ISO date `YYYY-MM-DD`; omitted = no lower bound. */
  fromDate?: string
  /** ISO date `YYYY-MM-DD`; omitted = no upper bound. */
  toDate?: string
}

const dashboardPnlApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPnLDashboard: builder.query<PnLDashboardResponse, PnLDashboardQuery>({
      query: ({ fromDate, toDate } = {}) => ({
        url: '/dashboard/pnl',
        params: {
          ...(fromDate ? { fromDate } : {}),
          ...(toDate ? { toDate } : {}),
        },
      }),
    }),
  }),
})

export const { useGetPnLDashboardQuery } = dashboardPnlApi
